import { createForm } from '@morgan-morgan/core';


createForm('.contact-form-container', {
    formId: window.NL.variables.forms.contactForm,
    theme: 'horizontal'
});


// WEBPACK FOOTER //
// ./assets/js/app/includes/contact-form.js